import { Routes, mapToCanActivate } from '@angular/router';
import { CustomerLocationGuard } from '@next/core-lib/relationships';

import { OrderReceiptComponent } from './components/overview-table/report/order-receipt.component';
import { FertilisersOverviewComponent } from './fertilisers-overview.component';

export const fertilisersOverviewRoutes: Routes = [
  {
    path: 'fertilizerOrders',
    canActivate: mapToCanActivate([CustomerLocationGuard]),
    component: FertilisersOverviewComponent,
  },
  {
    path: 'fertilizerOrders/report',
    component: OrderReceiptComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard]),
  },
];
